import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ServiceData from "../../data/service/ServiceMain.json";
import { slugify } from "../../utils";
import { useState } from "react";

const AllData = ServiceData;

const ServicePropOne = ({ colSize, serviceStyle, itemShow, marginTop }) => {
  const cardVariants = {
    hidden: {
      y: 50,
      opacity: 0,
      scale: 0.95,
    },
    visible: (i) => ({
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 150,
        damping: 8,
        mass: 0.5,
        delay: i * 0.15,
      },
    }),
    hover: {
      y: -10,
      transition: { type: "spring", stiffness: 300 },
    },
  };

  const topMargin = (index) => {
    if (marginTop === "yes") {
      if (index === 0) {
        return "mt--200 mt_md--0";
      } else if (index === 1) {
        return "mt--100 mt_md--0";
      } else {
        return "mt--0";
      }
    } else {
      return "";
    }
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust breakpoint
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {AllData.slice(1, itemShow).map((data, index) => (
        <motion.div
          className={`${colSize} ${topMargin(index)}`}
          key={index}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          whileHover="hover"
          viewport={{ once: true, margin: "0px 0px -50px 0px" }}
          custom={index}
        >
          <div className={`services-grid ${serviceStyle}`}>
            <div className="thumbnail">
              <img src={process.env.PUBLIC_URL + data.image} alt="icon" />
            </div>
            <div className="content">
              <h5 className="title">
                <Link
                  to={
                    process.env.PUBLIC_URL + `/service/${slugify(data.title)}`
                  }
                  className="more-btn"
                  style={{ paddingBottom: isMobile ? "0" : "inherit" }}
                >
                  {data.title}
                </Link>
              </h5>
              <p
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 5, // Limits to 4 lines
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  margin: isMobile ? "0" : "inherit", // Remove margin on mobile
                }}
              >
                {data.description}
              </p>
              <Link
                to={process.env.PUBLIC_URL + `/service/${slugify(data.title)}`}
                className="more-btn"
                style={{
                  paddingBottom: isMobile ? "30px" : "inherit", // Remove margin on mobile
                }}
              >
                Find out more {isMobile && "→"}
              </Link>
            </div>
          </div>
        </motion.div>
      ))}
    </>
  );
};

export default ServicePropOne;
